import { useEffect, useRef } from 'react'

/**
 * Canvas dither violeta atrás da saudação (identidade do protótipo
 * chat-first): pontos 2px em grade de 5px cuja densidade cai radialmente a
 * partir do topo central. É estático (nenhuma animação — nada a desligar no
 * prefers-reduced-motion); a cor vem do token --brand do tema ativo, então
 * redesenha quando a classe .dark do <html> muda.
 */
export function HomeDither() {
  const ref = useRef<HTMLCanvasElement>(null)

  useEffect(() => {
    const canvas = ref.current
    if (!canvas) return

    const draw = () => {
      const ctx = canvas.getContext('2d')
      if (!ctx) return
      const { width, height } = canvas
      ctx.clearRect(0, 0, width, height)
      const brand = getComputedStyle(document.documentElement).getPropertyValue('--brand').trim()
      if (!brand) return
      ctx.fillStyle = brand
      const cx = width / 2
      const cy = -30
      for (let y = 0; y < height; y += 5) {
        for (let x = 0; x < width; x += 5) {
          const distance = Math.hypot(x - cx, y - cy) / 260
          const presence = Math.max(0, 1 - distance)
          if (Math.random() < presence * presence * 0.5) {
            ctx.globalAlpha = 0.05 + presence * 0.22
            ctx.fillRect(x, y, 2, 2)
          }
        }
      }
      ctx.globalAlpha = 1
    }

    draw()
    const observer = new MutationObserver(draw)
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] })
    return () => observer.disconnect()
  }, [])

  return (
    <canvas
      ref={ref}
      width={900}
      height={240}
      aria-hidden="true"
      className="pointer-events-none absolute left-1/2 top-0 -translate-x-1/2 opacity-35 dark:opacity-55 md:-top-8"
    />
  )
}
